import React from "react";

const Button = ({ children, onClick, type = "button", disabled = false, variant = "primary", style = {} }) => {
  const base = {
    padding: "10px 20px",
    border: "none",
    borderRadius: 8,
    cursor: disabled ? "not-allowed" : "pointer",
    fontWeight: 600,
    fontSize: 14,
    opacity: disabled ? 0.6 : 1,
    transition: "all 0.15s ease",
    letterSpacing: 0.2,
    ...style,
  };

  const variants = {
    primary: { background: "#6c63ff", color: "#fff" },
    secondary: { background: "#e0e0e0", color: "#333" },
    danger: { background: "#e53935", color: "#fff" },
  };

  return (
    <button type={type} onClick={onClick} disabled={disabled} style={{ ...base, ...variants[variant] }}>
      {children}
    </button>
  );
};

export default Button;
